<div *ngIf="originalDisplayedColumns">
  <div class="selection-fields">
    <div class="column-selection-outer">
      Available Columns
      <div class="column-selection">
        <mat-selection-list #source class="mat-list-scrollable">
          <mat-list-option *ngFor="let column of visibleColumns" [ngClass]="{'active' : isSourceColumnSelected(column)}" [value]="column" (dblclick)="dblClickMoveOver(column)">
            {{column.headertxt}}
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>
    <div class="column-buttons">
      <div>
        <i class="move-multiple-over-icon padding-t10" [class.disabled]="hideMoveMultipleOver" aria-hidden="true" (click)="moveOver()"></i>
      </div>
      <div>
        <i class="move-single-over-icon padding-t10" [class.disabled]="hideMoveSingleOver" aria-hidden="true" (click)="moveOver()"></i>
      </div>
      <div>
        <i class="move-single-back-icon padding-t10" [class.disabled]="hideMoveSingleBack" aria-hidden="true" (click)="moveBack()"></i>
      </div>
      <div>
        <i class="move-multiple-back-icon padding-t10" [class.disabled]="hideMoveMultipleBack" aria-hidden="true" (click)="moveBack()"></i>
      </div>
      <div class="refresh-btn">
        <i class="refresh-icon padding-t10" aria-hidden="true" [class.disabled]="destination.options && destination.options.length === 0" (click)="refresh()"></i>
      </div>
    </div>
    <div class="column-selection-outer">
      Displayed Columns
      <div class="column-selection">
        <mat-selection-list #destination class="mat-list-scrollable">
          <mat-list-option *ngFor="let column of selectedColumns" [ngClass]="{'active' : isDestinationColumnSelected(column)}" [value]="column" (dblclick)="dblClickMoveBack(column)">
            {{column.headertxt}}
          </mat-list-option>
        </mat-selection-list>
      </div>
    </div>
  </div>
  <div class="move-up-down">
    <p>Change Order: </p>
    <i class="up-arrow-icon" [class.disabled]="destination.selectedOptions.selected.length !== 1" aria-hidden="true" (click)="moveUp()"></i>
    <i class="down-arrow-icon" [class.disabled]="destination.selectedOptions.selected.length !== 1" aria-hidden="true" (click)="moveDown()"></i>
  </div>
</div>
